module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v(_vm._s(_vm.pageheader))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Allgemeine Informationen  "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/undertakers/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "undertaker_name"
    }
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.name),
      expression: "model.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "undertaker_name",
      "id": "undertaker_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveGraveyard()
      }
    }
  }, [_vm._v("Speichern")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.model.id > 0),
      expression: "model.model.id > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "addresses"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.addresses.cols,
      "src-model": _vm.model.addresses,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addAddress,
      "edit": _vm.editAddress,
      "delete": _vm.deleteAddress
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "contacts"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.contacts.cols,
      "src-model": _vm.model.contacts,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addContact,
      "edit": _vm.editContact,
      "delete": _vm.deleteContact
    }
  })], 1)])])])])], 1)])]), _vm._v(" "), _c('custom-modal', {
    ref: "addressModal",
    attrs: {
      "title": "Adresse hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('address-content', {
    ref: "newAddress"
  })], 1), _vm._v(" "), _c('custom-modal', {
    ref: "contactModal",
    attrs: {
      "title": "Kontakt hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('contact-content', {
    ref: "newContact"
  })], 1), _vm._v(" "), (_vm.visibleModal === 'deletecontacts') ? _c('custom-modal-old', {
    attrs: {
      "title": "Kontakt entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('contacts')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'deleteaddresses') ? _c('custom-modal-old', {
    attrs: {
      "title": "Adresse entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('addresses')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diese Adresse entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'errSavingModel') ? _c('custom-modal-old', {
    attrs: {
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\n\t\t\tFehler beim Speichern des Kunden.\n\t\t")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": "/graveyards/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "href": "/graveyards/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#addresses"
    }
  }, [_vm._v("Adressen")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#contacts"
    }
  }, [_vm._v("Kontakte")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eeaf75ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GraveyardEdit.vue
// module id = 465
// module chunks = 0